import { useOverlays } from "../../../contexts/OverlayContext";
import { ReferralDrawer } from "./ReferralDrawer";

export const ReferralDrawerContainer: React.FC = () => {
    const { getOverlayInfo } = useOverlays();
    const overlayInfo = getOverlayInfo("referralDrawer");

    if (!overlayInfo) {
        return null;
    }

    return <ReferralDrawer />;
};
